import React from 'react'
import { Link } from 'react-router-dom'
import {INews} from '../../../models/News'
import {defaultOgHeight, defaultOgWidth, UrlPrefix, UserType} from '../../config/constants'
import {getGlobalEnv} from '../../helpers/coreUtil'
import {dateWithSlashOption, FormattedDateClient} from '../../helpers/dateUtil'
import {getNewsUrl} from '../../helpers/news'
import {getFitInUrl} from '../../helpers/util'
import AmpLink from '../common/AmpLink'
import ResponsiveImg from '../common/ResponsiveImg'
import {useLocale, useSEO} from '../hocs/hooks'
import SNS from '../post/SNS'
import Preview from '../quill/Preview'
import styles from './NewsPreview.scss'

const NewsPreview = ({news}: {news: INews}) => {
  const {
    summary,
    photo,
    content,
    title,
    date,
  } = news
  const cdn = getGlobalEnv('CDN_BASE_URL')
  const locale = useLocale()
  const ogImage = getFitInUrl(photo, defaultOgWidth, defaultOgHeight, {webp: false, cdn})
  useSEO({
    title,
    description: summary,
    ogImage,
    ogWidth: defaultOgWidth,
    ogHeight: defaultOgHeight,
    canonicalUrl: getNewsUrl(locale, news, true, false)
  })
  const post = { summary: `${title} @CarstayJP`}
  return <>
    <div className={['mx-auto', styles.container].join(' ')}>
      <div className={['form-group'].join(' ')}>
        <h4 className="font-weight-medium"><FormattedDateClient value={date} {...dateWithSlashOption}/></h4>
      </div>
      <h1 className={['font-weight-bold pb-2', styles.title].join(' ')}>
        {title}
      </h1>
      <div className="my-4">{summary}</div>
      <ResponsiveImg
        url={photo}
        caption={title}
      />
      <div className="my-4"><SNS post={post} url={getNewsUrl(locale, news, true, false)}/></div>
      <Preview content={content}/>
      <div className={['mt-4 position-relative'].join(' ')}>
        <div className={['position-absolute h-100', styles.leftBar].join(' ')}/>
        <div className={['rounded pl-3', styles.headerBar].join(' ')}>
          Carstay株式会社について
        </div>
      </div>
      <div className={['mt-2', styles.content].join(' ')}>
        Carstay株式会社は「誰もが好きな時に、好きな場所で、好きな人と過ごせる世界をつくる」というミッションを掲げ、
        “移動”を基盤にあらゆるサービスを提供する概念「MaaS（Mobility as a Service）」
        領域で新しい旅と暮らしのライフスタイル「VANLIFE（バンライフ）」をテーマに事業を展開するスタートアップ企業です。
        今後、5G・自動運転社会の到来で必要となる「快適な移動」と「感動体験」を「VANLIFE」プラットフォームの提供を通じてデザインします。
        2018年6月に創業。（<AmpLink to={`/ja${UrlPrefix[UserType.user]}/`}>https://carstay.jp/</AmpLink>）
      </div>
      <div className={['mt-4 position-relative'].join(' ')}>
        <div className={['position-absolute h-100', styles.leftBar].join(' ')}/>
        <div className={['rounded pl-3', styles.headerBar].join(' ')}>
          報道関係者向けの問合わせ先
        </div>
      </div>
      <div className={['mt-2', styles.content].join(' ')}>
        <div>Carstay株式会社</div>
        <div>広報担当 中川生馬（なかがわ いくま）</div>
        <div>・電話： 080-4476-1106</div>
        <div>・E-mail： i.nakagawa@carstay.jp</div>
        <div>※こちらは報道関係に関する問い合わせ先です。広告・宣伝、ユーザー（ゲスト・ホスト・ホルダー）様からのお問い合わせは、お手数ではございますが、以下からお願いいたします。</div>
        <div><Link to={`/${locale}/contact/`}>https://carstay.jp/{locale}/contact/</Link></div>
      </div>
    </div>
  </>
}
NewsPreview.displayName = 'NewsPreview'
export default NewsPreview
